import React from "react";
import { useRouteMatch } from "react-router-dom";
import ProtectedRoute from "../../components/protected-route";
import Dashboard from "./dashboard";
import Drawer from "../../components/drawer";
import { menus } from "./menus";
import Header from "../../components/header";
import { useDispatch, useSelector } from "react-redux";
import withMiddleware from "../../middleware";
import { UserContext } from "../../context";
import { logoutUser } from "../../actions";
import ComingSoon from "../../components/coming-soon";

function UserHome(props) {
  let { path } = useRouteMatch();
  const dispatch = useDispatch();
  const { user } = useSelector((state) => ({
    user: state.app.user,
  }));
  const { location, history } = props;

  const options = [
    {
      id: 1,
      label: "Sign out",
    },
  ];

  function signOut(id) {
    dispatch(logoutUser());
  }

  return (
    <>
      {user ? (
        <UserContext.Provider value={user}>
          <Drawer menuItems={menus} onChangeMenu={(menu) => {}} />
          <Header options={options} history={history} onMenuClick={(id) => signOut(id)} />
          <ProtectedRoute exact path={path} component={ComingSoon} />
          <ProtectedRoute exact path={`${path}/history/morning`} component={ComingSoon} />
          <ProtectedRoute exact path={`${path}/history/biofeedback`} component={ComingSoon} />
          <ProtectedRoute exact path={`${path}/history/mindfulness`} component={ComingSoon} />
          <ProtectedRoute exact path={`${path}/history/self-compassion`} component={ComingSoon} />
        </UserContext.Provider>
      ) : (
        <div />
      )}
    </>
  );
}

export default withMiddleware(UserHome);
